define('drops/calendarPlanningView/calendarPlanningView',[
    'jquery',
    'underscore',
    'luxon',
    'lq/constants',
    'globalize',
    'lq/drop',
    'drops/calendar/calendarParameter',
    'drops/calendar/calendarItems',
    'lq/nestingContext',
    'lq/multiSourceValue',
    'tpl!drops/calendarPlanningView/calendarPlanningView.html',
    'lq/onlongpress'
], function ($, _, luxon, constants, globalize, Drop, calendarParameter, calendarItems, NestingContext, multiSourceValue, template, OnLongPress) {
    'use strict';

    const { DateTime } = luxon;

    var defaults = {
        data: {
            type: 'CalendarPlanningView',
            dataSource: null,
            dataSourceType: 'datetimes',
            dateOutput: null,
            startOutput: null,
            endOutput: null,
            groupOutput: null,
            groupsDataSource: null,
            groupsIdOutput: null,
            calendarStartParameter: 'CalendarDayStart',
            calendarEndParameter: 'CalendarDayEnd',
            timeslotSize: 60,
            dayStart: 0,
            dayEnd: (60 * 24) - 1,
            titleFormat: 'D',
            timeslotHourFormat: 'HH:mm',
            longPressDelay: 1000
        },
        childDrops: [
            { data: { type: 'CalendarItem', layoutMode: 'horizontal' } },
            { data: { type: 'GroupItem' } },
            { data: { type: 'CalendarTimeSlotItem', size: { x: 60, y: 40 } },
            childDrops: [
                {
                    data: {
                        type: 'DynamicText',
                        name: 'timeLabel',
                        size: { x: 50, y: 30 },
                        position: { x: 0, y: 0 },
                        top:5,
                        left:5,
                        right:5,
                        bottom: 5,
                        styles: {
                            normal: {
                                enabled: true,
                                font: {
                                    color: '#000000',
                                    fontFamily: 'Arial,Arial,Helvetica,sans-serif',
                                    size: 12,
                                },
                                text: {
                                    lineHeight: 12,
                                    align: 'center',
                                    verticalAlign: 'middle'
                                    }
                            }
                        }
                    }
                }
            ]
            }
        ]
    };

    function CalendarPlanningView(options) {
        var defaultsWhenNew = (options.data?.id) ? null : defaults;
        Drop.call(this, $(template()), defaultsWhenNew, options);
        this.selectedDate = null;
    }

    Drop.extend(CalendarPlanningView, Drop);

    CalendarPlanningView.typeName = 'CalendarPlanningView';

    CalendarPlanningView.prototype.applyPosition = $.noop;

    CalendarPlanningView.prototype.init = function () {
        this.nestingContext = new NestingContext(this.piping);

        multiSourceValue.initialize(
            this,
            this.data.scrollPosition,
            this.goToScrollToPosition.bind(this));
    };

    CalendarPlanningView.prototype.goToScrollToPosition = function (scrollPosition) {
        if (this.isValidISOFormat(scrollPosition)) {
            scrollPosition = this.getMinutesFromMidnight(scrollPosition);
        }

        if (!$.isNumeric(scrollPosition)) {
            return;
        }

        var slotNumber = Math.floor((scrollPosition - this.data.dayStart) / this.data.timeslotSize);
        var $timeslots = this.$planningGroups.find('.timeslots').first();
        if (!$timeslots.length || !$timeslots.children('.timeslot').length) {
            this.pendingScrollPosition = scrollPosition;
            return;
        }
        var $slot = $timeslots.children('.timeslot').eq(slotNumber);
        if ($slot.length) {
            this.$container.scrollLeft(this.$container.scrollLeft() + $slot.position().left);
            this.pendingScrollPosition = null;
        }
    };

    CalendarPlanningView.prototype.getMinutesFromMidnight = function (dateString) {
        var date = new Date(dateString);
        return date.getHours() * 60 + date.getMinutes();
    };

    CalendarPlanningView.prototype.isValidISOFormat = function (input) {
        if (typeof input !== "string") {
            return false;
        }
        return DateTime.fromISO(input).isValid;
    };

    CalendarPlanningView.prototype.loadCalendarData = function () {
        var dateOfRequestedData = this.date;
        var self = this;

        calendarItems.showLoadingOverlay(this);

        var loadItems = function (groups) {
            if (!self.data.dataSource) {
                calendarItems.hideLoadingOverlay(self);
                return;
            }
            self.piping.queryDispatcher.backgroundDispatch(
                self.data.dataSource,
                function (response) {
                    if (dateOfRequestedData.equals(self.date)) {
                        self.removeCalendarItems();
                        self.showItems(response.outputs, response.results, groups);
                    }
                });
        };

        if (this.data.groupsDataSource) {
            if (this.groups && this.groups.length > 0) {
                loadItems(this.groups);
            } else {
                this.piping.queryDispatcher.backgroundDispatch(
                    this.data.groupsDataSource,
                    function (response) {
                        if (dateOfRequestedData.equals(self.date)) {
                            var groups = (response.results || []).map(function (row) {
                                var id = self.data.groupsIdOutput ? row[self.data.groupsIdOutput] : null;
                                return { id: id, row: row };
                            });
                            self.setGroups(groups, response.outputs);
                            self.recreateTimeslots();
                            loadItems(groups);
                        } else {
                            calendarItems.hideLoadingOverlay(self);
                        }
                    });
            }
        } else {
            self.setGroups([]);
            loadItems([]);
        }

        if (!this.data.activeTSDataSource)
            return;

        this.piping.queryDispatcher.backgroundDispatch(
            this.data.activeTSDataSource,
            function (response) {
                if (dateOfRequestedData.equals(self.date))
                    self.setActiveTimeslots(response.results);
            });
    };

    CalendarPlanningView.prototype.setSelectedDate = function (date) {
        this.selectedDate = date;
    };

    CalendarPlanningView.prototype.clearSelectedDate = function () {
        this.selectedDate = null;
    };

    CalendarPlanningView.prototype.getSelectedDate = function () {
        return this.selectedDate;
    };

    CalendarPlanningView.prototype.render = function () {
        this.setGroups([]);
        this.registerForDataSource();
        this.prepareUi();
        this.createTimeslots();
        this.open(DateTime.now());
    };

    CalendarPlanningView.prototype.prepareUi = function () {
        this.$container = this.$element.find('.planning-scroll-area');
        this.$title = this.$element.find('.date-as-title');
        this.$hours = this.$element.find('.hours').first();
        this.$planningGroups = this.$element.find('.planning-groups');
        this.$planningLabelsColumn = this.$element.find('.planning-labels-column');
        this.$hoursScrollWrapper = this.$element.find('.hours-scroll-wrapper');
        this.$headerHoursCorner = this.$element.find('.planning-header .hours-corner');

        this.$element.find('.previous-page')
            .on('click', this.previous.bind(this));
        this.$element.find('.next-page')
            .on('click', this.next.bind(this));
    };

    CalendarPlanningView.prototype.setGroups = function (groups, outputs) {
        this.groups = groups || [];
        this.groupsOutputs = outputs || {};
    };

    CalendarPlanningView.prototype.recreateTimeslots = function () {
        this.$hours.empty();
        this.$planningGroups.empty();
        this.createTimeslots();
    };

    CalendarPlanningView.prototype.createTimeslots = function () {
        var timeslots = _.range(this.data.dayStart, this.data.dayEnd, this.data.timeslotSize);
        if (this.designData && timeslots.length > 0)
            timeslots = [timeslots[0]];
        var groups = this.groups || [];
        var hasGroups = groups.length > 0;
        var groupItemTemplate = _.find(this.childDrops, function (d) { return d.data && d.data.type === 'GroupItem'; });
        var timeslotItemTemplate = _.find(this.childDrops, function (d) { return d.data && d.data.type === 'CalendarTimeSlotItem'; });
        var hasGroupItemTemplate = !!groupItemTemplate;
        var hasTimeslotItemTemplate = !!timeslotItemTemplate;
        var timeslotTemplateWidth = (timeslotItemTemplate && timeslotItemTemplate.data && timeslotItemTemplate.data.size && timeslotItemTemplate.data.size.x != null)
            ? timeslotItemTemplate.data.size.x : 30;
        var timeslotTemplateHeight = (timeslotItemTemplate && timeslotItemTemplate.data && timeslotItemTemplate.data.size && timeslotItemTemplate.data.size.y != null)
            ? timeslotItemTemplate.data.size.y : 60;

        this.removeGroupItems();
        this.removeTimeslotItems();

        var self = this;
        var groupLabelWidth = 80;
        if (hasGroupItemTemplate && groupItemTemplate.data && groupItemTemplate.data.size && groupItemTemplate.data.size.x != null) {
            groupLabelWidth = groupItemTemplate.data.size.x;
        }
        var shouldRenderPlaceholderRow = !!this.designData;

        this.$planningLabelsColumn.empty();
        this.$hours.empty();
        this.$planningGroups.empty();
        if (this.$headerHoursCorner && this.$headerHoursCorner.length) {
            this.$headerHoursCorner.css({ width: '', minWidth: '', maxWidth: '' });
            this.$headerHoursCorner.addClass('planning-header-corner-empty');
        }

        var $planningLabels = $('<div />').addClass('planning-labels');
        var hasLabels = hasGroups || hasGroupItemTemplate;
        if (hasLabels && this.$headerHoursCorner && this.$headerHoursCorner.length) {
            this.$headerHoursCorner.removeClass('planning-header-corner-empty').css({
                width: groupLabelWidth + 'px'
            });
        }
        var $hours = _.map(timeslots, function (slot) {
            var date = new Date(1970, 0, 1);
            date.setMinutes(slot);
            var slotLabel = globalize.format(date, self.data.timeslotHourFormat);
            var $timeslot = $('<div />')
                .addClass('timeslot')
                .data('time', slot);
            if (hasTimeslotItemTemplate && !self.designData) {
                var slotData = {
                    timeLabel: slotLabel,
                    slotStartMinute: slot,
                    slotEndMinute: slot + self.data.timeslotSize
                };
                var timeslotDropData = $.extend(true, {}, timeslotItemTemplate, {
                    data: {
                        slotLabel: slotLabel,
                        slotStartMinute: slot,
                        slotEndMinute: slot + self.data.timeslotSize,
                        slotRow: slotData,
                        slotOutputs: {
                            timeLabel: 'String',
                            slotStartMinute: 'Number',
                            slotEndMinute: 'Number'
                        }
                    }
                });
                var timeslotDrop = self.piping.dropFactory.createDrop(timeslotDropData);
                self.addDrop(timeslotDrop);
                self.timeslotItemDrops = self.timeslotItemDrops || [];
                self.timeslotItemDrops.push(timeslotDrop);
                timeslotDrop.render($timeslot);
                timeslotDrop.applyPosition();
            } 
       
            return $timeslot; 
        });

        this.$hours.append($hours);
        this.$hours.children('.timeslot').css({
            width: timeslotTemplateWidth + 'px',
            minWidth: timeslotTemplateWidth + 'px',
            height: timeslotTemplateHeight + 'px',
            lineHeight: timeslotTemplateHeight + 'px'
        });

        var createTimeslotRow = function (group) {
            var groupId = group ? group.id : null;
            var groupRow = group ? group.row : {};
            var $group = $('<div />').addClass('planning-group').data('groupId', groupId);
            var $groupLabel = $('<div />').addClass('group-label').css({
                width: groupLabelWidth + 'px',
            });
            if (hasGroupItemTemplate) {
                var groupItemData = $.extend(true, {}, groupItemTemplate, {
                    data: {
                        groupId: groupId,
                        groupRow: groupRow,
                        groupOutputs: self.groupsOutputs || {}
                    }
                });
                var groupDrop = self.piping.dropFactory.createDrop(groupItemData);
                self.addDrop(groupDrop);
                self.groupItemDrops = self.groupItemDrops || [];
                self.groupItemDrops.push(groupDrop);
                groupDrop.render($groupLabel);
                groupDrop.applyPosition();
            } else if (hasGroups && groupRow && self.data.groupsIdOutput && groupRow[self.data.groupsIdOutput] != null) {
                $groupLabel.text(String(groupRow[self.data.groupsIdOutput]));
            }
            if (hasGroupItemTemplate || (hasGroups && group)) {
                $planningLabels.append($groupLabel);
            }
            var $timeslots = $('<div />').addClass('timeslots');
            $timeslots.append($('<div class="calendar-item-container"/>'));
            var $slotElements = _.map(timeslots, function (startMinute) {
                var $timeslot = $('<div />')
                    .addClass('timeslot')
                    .data('time', startMinute)
                    .css({
                        width: timeslotTemplateWidth + 'px',
                        minWidth: timeslotTemplateWidth + 'px',
                        height: timeslotTemplateHeight + 'px'
                    });

                new OnLongPress().applyLongPressOnElement($timeslot, self,
                    function () {
                        return self.determineEventArg(startMinute);
                    }, function () {
                        self.timeslotClicked(startMinute);
                    });

                $timeslot.on("mousedown", calendarItems.timeslotMousedown.bind(self, $timeslots.find('.calendar-item-container'), 0));
                $timeslot.on("mouseup", calendarItems.timeslotMouseup.bind(self));
                $timeslot.on("mousemove", calendarItems.timeslotMousemove.bind(self));

                return $timeslot;
            });
            $timeslots.append($slotElements);
            $group.append($timeslots);
            return $group;
        };

        if (hasLabels) {
            this.$planningLabelsColumn.append($planningLabels);
            this.$planningLabelsColumn.removeClass('planning-labels-empty');
        } else {
            this.$planningLabelsColumn.addClass('planning-labels-empty');
        }

        if (hasGroups) {
            _.each(groups, function (g) {
                self.$planningGroups.append(createTimeslotRow(g));
            });
        } else if (shouldRenderPlaceholderRow) {
            this.$planningGroups.append(createTimeslotRow(null));
        }

        if (hasLabels) {
            $planningLabels.append($('<div class="group-label labels-scrollbar-spacer"></div>'));
        }

        this.syncLabelsScroll();
        this.syncHoursScroll();

        if (this.pendingScrollPosition != null) {
            var pending = this.pendingScrollPosition;
            this.pendingScrollPosition = null;
            this.goToScrollToPosition(pending);
        }
    };

    CalendarPlanningView.prototype.updateHoursSpacerWidth = function (width) {
        if (this.$headerHoursCorner && this.$headerHoursCorner.length && !this.$headerHoursCorner.hasClass('planning-header-corner-empty')) {
            this.$headerHoursCorner.css({
                width: width + 'px',
                minWidth: width + 'px',
                maxWidth: width + 'px'
            });
        }
    };

    CalendarPlanningView.prototype.syncHoursScroll = function () {
        var $scrollArea = this.$container;
        var $hoursWrapper = this.$hoursScrollWrapper;
        if (!$scrollArea.length || !$hoursWrapper.length)
            return;

        var syncing = false;
        $scrollArea.off('scroll.planningHoursSync').on('scroll.planningHoursSync', function () {
            if (syncing) return;
            syncing = true;
            $hoursWrapper.scrollLeft($scrollArea.scrollLeft());
            syncing = false;
        });
        $hoursWrapper.off('scroll.planningHoursSync').on('scroll.planningHoursSync', function () {
            if (syncing) return;
            syncing = true;
            $scrollArea.scrollLeft($hoursWrapper.scrollLeft());
            syncing = false;
        });
    };

    CalendarPlanningView.prototype.syncLabelsScroll = function () {
        var $scrollArea = this.$container;
        var $labels = this.$planningLabelsColumn.children('.planning-labels');
        if (!$scrollArea.length || !$labels.length)
            return;

        var syncing = false;
        $scrollArea.off('scroll.planningLabelsSync').on('scroll.planningLabelsSync', function () {
            if (syncing) return;
            syncing = true;
            $labels.scrollTop($scrollArea.scrollTop());
            syncing = false;
        });
        $labels.off('scroll.planningLabelsSync').on('scroll.planningLabelsSync', function () {
            if (syncing) return;
            syncing = true;
            $scrollArea.scrollTop($labels.scrollTop());
            syncing = false;
        });
    };

    CalendarPlanningView.prototype.removeGroupItems = function () {
        if (this.groupItemDrops) {
            _.each(this.groupItemDrops, function (drop) {
                drop.$element.remove();
                this.removeDrop(drop);
            }, this);
            this.groupItemDrops = [];
        }
    };

    CalendarPlanningView.prototype.removeTimeslotItems = function () {
        if (this.timeslotItemDrops) {
            _.each(this.timeslotItemDrops, function (drop) {
                drop.$element.remove();
                this.removeDrop(drop);
            }, this);
            this.timeslotItemDrops = [];
        }
    };

    CalendarPlanningView.prototype.determineEventArg = function (startMinute) {
        var dateAndTime = this.date
            .startOf('day')
            .plus({ minutes: startMinute });
        return globalize.format(dateAndTime.toJSDate(), constants.licquidDateFormat);
    };

    CalendarPlanningView.prototype.timeslotClicked = function (startMinute) {
        var eventArg = this.determineEventArg(startMinute);
        this.triggerEvent(this.data.eventing.clicked.raisedEventName, eventArg);
    };

    CalendarPlanningView.prototype.registerForDataSource = function () {
        if (this.data.dataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data, isUpdate) {
                if (isUpdate) {
                    self.removeCalendarItemsPendingServerId();
                    if (!self.data.idOutput || !data.results || !data.results.length)
                        return;
                    var ids = _.uniq(
                        _.map(data.results, function (row) { return row[self.data.idOutput]; })
                            .filter(function (id) { return id !== undefined && id !== null; }),
                        false,
                        function (id) { return String(id); }
                    );
                    self.removeCalendarItemsForIds(ids);
                    self.showItems(data.outputs, data.results, self.groups || []);
                } else {
                    self.removeCalendarItems();
                    self.showItems(data.outputs, data.results, self.groups || []);
                }
            });
        }

        if (this.data.groupsDataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.groupsDataSource, function (data, isUpdate) {
                if (isUpdate && (!data.results || !data.results.length))
                    return;

                if (isUpdate) {
                    self.groups = self.groups || [];
                    _.each(data.results, function (row) {
                        var id = self.data.groupsIdOutput ? row[self.data.groupsIdOutput] : null;
                        var idx = _.findIndex(self.groups, function (g) {
                            return self.idsMatch(g.id, id);
                        });
                        var entry = { id: id, row: row };
                        if (idx >= 0)
                            self.groups[idx] = entry;
                        else
                            self.groups.push(entry);
                    });
                    self.groupsOutputs = $.extend({}, self.groupsOutputs || {}, data.outputs);
                } else {
                    var groups = (data.results || []).map(function (row) {
                        var id = self.data.groupsIdOutput ? row[self.data.groupsIdOutput] : null;
                        return { id: id, row: row };
                    });
                    self.setGroups(groups, data.outputs);
                }
                self.removeCalendarItems();
                self.recreateTimeslots();
                self.loadCalendarData();
            });
        }

        if (this.data.activeTSDataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.activeTSDataSource, function (data, _isUpdate) {
                self.setActiveTimeslots(data.results);
            });
        }
    };

    CalendarPlanningView.prototype.previous = function () {
        this.open(this.date.minus({ days: 1 }));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarPlanningView.prototype.next = function () {
        this.open(this.date.plus({ days: 1 }));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarPlanningView.prototype.triggerNavigatedEvent = function () {
        this.triggerEventIfEnabled('navigated', this.date);
    };

    CalendarPlanningView.prototype.open = function (date) {
        this.date = date;
        this.updateTitle();
        this.removeCalendarItems();

        var parameters = this.piping.parameters;
        parameters.locals.setValue(this.data.calendarStartParameter, calendarParameter.convert(this.date.startOf('day')));
        parameters.locals.setValue(this.data.calendarEndParameter, calendarParameter.convert(this.date.endOf('day')));
    };

    CalendarPlanningView.prototype.getOpenDate = function () {
        return this.date;
    };

    CalendarPlanningView.prototype.updateTitle = function () {
        var title = globalize.format(this.date.toJSDate(), this.data.titleFormat);
        this.$title.text(title);
    };

    CalendarPlanningView.prototype.splitDateRangeAtMidnight = function (startOfItem, endOfItem) {
        var items = [];
        var currentStart = startOfItem;

        while (currentStart.startOf('day') < endOfItem.startOf('day')) {
            var currentEnd = currentStart.endOf('day');
            items.push({ start: currentStart, end: currentEnd });
            currentStart = currentStart.plus({ days: 1 }).startOf('day');
        }

        items.push({ start: currentStart, end: endOfItem });
        return items;
    };

    CalendarPlanningView.prototype.getContainerForGroupId = function (groupId) {
        var $groups = this.$planningGroups.find('.planning-group');
        if (groupId == null || $groups.length === 0)
            return $groups.first().find('.calendar-item-container');
        var $group = $groups.filter(function () {
            var gId = $(this).data('groupId');
            return gId == groupId || String(gId) === String(groupId);
        });
        return ($group.length ? $group : $groups).first().find('.calendar-item-container');
    };

    CalendarPlanningView.prototype.showItems = function (outputs, rows, groups) {
        var startOfDay = this.date.startOf('day').plus({ minutes: this.data.dayStart });
        var endOfDay = this.date.startOf('day').plus({ minutes: this.data.dayEnd });
        var hasGroups = (groups || []).length > 0 && this.data.groupOutput;

        var self = this;
        var items = [];

        var calendarItemTemplate = _.find(this.childDrops, function (d) { return d.data && d.data.type === 'CalendarItem'; }) || this.childDrops[0];

        _.each(rows, function (row) {
            var rowGroupId = hasGroups && self.data.groupOutput ? row[self.data.groupOutput] : null;
            var $target = self.getContainerForGroupId(rowGroupId);

            var startOfItem = self.getDatetimeFromRow(row, self.data.startOutput);
            var endOfItem = self.getDatetimeFromRow(row, self.data.endOutput);

            var splitItems = self.splitDateRangeAtMidnight(startOfItem, endOfItem);

            _.each(splitItems, function (splitItem) {
                if (!splitItem.start.startOf('day').equals(self.date.startOf('day')))
                    return;
                items.push($.extend(true, {}, calendarItemTemplate, {
                    data: {
                        $target: $target,
                        startOfDay: startOfDay,
                        endOfDay: endOfDay,
                        startOfItem: splitItem.start,
                        endOfItem: splitItem.end,
                        row: row,
                        outputs: outputs,
                        eventArg: calendarItemTemplate.data.eventArg || self.data.eventArg,
                        tooltipOutput: self.data.tooltipOutput,
                        idOutput: self.data.idOutput,
                        layoutMode: 'horizontal',
                        groupId: rowGroupId
                    }
                }));
            });
        });

        calendarItems.fillUp(this, items)
            .then(function () {
                self.nestingContext.executeDataSources();
            })
            .ensure(function () {
                calendarItems.hideLoadingOverlay(self);
            })
            .catch(function (e) {
                self.piping.errorHandler.showErrorDialog(e);
            });
    };

    CalendarPlanningView.prototype.removeCalendarItems = function () {
        var self = this;
        _.each(this.pool.slice(0), function (drop) {
            if (drop.type === 'CalendarItem') {
                drop.$element.remove();
                self.removeDrop(drop);
            }
        });
        this.data.calendarItemGroups = [];
    };

    CalendarPlanningView.prototype.idsMatch = function (a, b) {
        return a === b || String(a) === String(b);
    };

    /**
     * Drops drawn client-side (onCreate) still have an empty row or no Id output value until the server echoes the row.
     * Remove those before applying an updatable query result so the ghost block does not sit next to the real row (or disappear on empty/failed responses).
     */
    CalendarPlanningView.prototype.removeCalendarItemsPendingServerId = function () {
        var self = this;
        var idOut = this.data.idOutput;
        var toRemove = _.filter(this.pool, function (drop) {
            if (drop.type !== 'CalendarItem' || !drop.data)
                return false;
            var row = drop.data.row;
            if (!row || _.isEmpty(row))
                return true;
            if (idOut && (row[idOut] === undefined || row[idOut] === null))
                return true;
            return false;
        });
        if (!toRemove.length)
            return;
        _.each(toRemove, function (drop) {
            drop.$element.remove();
            self.removeDrop(drop);
        });
        if (this.data.calendarItemGroups && this.data.calendarItemGroups.length) {
            var poolSet = {};
            _.each(this.pool, function (p) { poolSet[p] = true; });
            this.data.calendarItemGroups = _.filter(this.data.calendarItemGroups, function (g) {
                return g.groupMembers && _.every(g.groupMembers, function (m) { return poolSet[m]; });
            });
        }
    };

    /** Removes calendar items for the given row ids (Id output); cleans calendarItemGroups. Used for updatable datasource partial results. */
    CalendarPlanningView.prototype.removeCalendarItemsForIds = function (ids) {
        if (!this.data.idOutput || !ids || !ids.length)
            return;
        var self = this;
        var toRemove = _.filter(this.pool, function (drop) {
            if (drop.type !== 'CalendarItem' || !drop.data || !drop.data.row)
                return false;
            var id = drop.data.row[self.data.idOutput];
            return _.some(ids, function (targetId) {
                return self.idsMatch(id, targetId);
            });
        });
        _.each(toRemove, function (drop) {
            drop.$element.remove();
            self.removeDrop(drop);
        });
        if (this.data.calendarItemGroups && this.data.calendarItemGroups.length) {
            var poolSet = {};
            _.each(this.pool, function (p) { poolSet[p] = true; });
            this.data.calendarItemGroups = _.filter(this.data.calendarItemGroups, function (g) {
                return g.groupMembers && _.every(g.groupMembers, function (m) { return poolSet[m]; });
            });
        }
    };

    CalendarPlanningView.prototype.getDatetimeFromRow = function (row, output) {
        if (this.data.dataSourceType === 'datetimes')
            return DateTime.fromISO(row[output]);

        var date = this.date.startOf('day');
        var time = row[output];
        return date.plus({ seconds: time });
    };

    CalendarPlanningView.prototype.setActiveTimeslots = function (rows) {
        var self = this;
        var $timeslots = self.$planningGroups.find('.timeslot');
        var $activeTimeslots = $();

        rows.forEach(function (row) {
            var activeTSStart = self.getDatetimeFromRow(row, self.data.activeTSStartOutput).toJSDate();
            var activeTSEnd = self.getDatetimeFromRow(row, self.data.activeTSEndOutput).toJSDate();

            var $filteredTimeslots = $timeslots.filter(function () {
                var time = $(this).data('time');
                return time >= self.getTimeOfDay(activeTSStart) && time < self.getTimeOfDay(activeTSEnd);
            });

            $activeTimeslots.push.apply($activeTimeslots, $filteredTimeslots);
        });

        $activeTimeslots.addClass('active-timeslot');
        $timeslots.not($activeTimeslots).removeClass('active-timeslot');
    };

    CalendarPlanningView.prototype.getTimeOfDay = function (date) {
        return date.getHours() * 60 + date.getMinutes();
    };

    CalendarPlanningView.prototype.updatePlanningViewRowHeights = function () {
        var self = this;
        var $containers = this.$planningGroups.find('.calendar-item-container');
        var calendarItemTemplate = _.find(this.childDrops, function (d) { return d.data && d.data.type === 'CalendarItem'; }) || this.childDrops[0];
        var baseHeight = (calendarItemTemplate && calendarItemTemplate.data && calendarItemTemplate.data.size && calendarItemTemplate.data.size.y != null)
            ? calendarItemTemplate.data.size.y : 60;
        var groupItemTemplate = _.find(this.childDrops, function (d) { return d.data && d.data.type === 'GroupItem'; });
        var minRowHeight = (groupItemTemplate && groupItemTemplate.data && groupItemTemplate.data.size && groupItemTemplate.data.size.y != null)
            ? groupItemTemplate.data.size.y : 60;
        var timeSlotItemTemplate = _.find(this.childDrops, function (d) { return d.data && d.data.type === 'CalendarTimeSlotItem'; });
        var timeSlotHeight = (timeSlotItemTemplate && timeSlotItemTemplate.data && timeSlotItemTemplate.data.size && timeSlotItemTemplate.data.size.y != null)
            ? timeSlotItemTemplate.data.size.y : 0;

        var $groupLabels = this.$planningLabelsColumn.find('.planning-labels .group-label');
        $containers.each(function (index) {
            var maxCols = parseInt($(this).attr('data-max-overlap-columns'), 10) || 0;

            var $timeslots = $(this).closest('.timeslots');
            var $groupLabel = $groupLabels.eq(index);
            var groupItemHeight = $groupLabel.length ? ($groupLabel.find('.group-item').outerHeight() || 0) : 0;
            var rowHeight = self.designData
                ? Math.max(groupItemHeight, minRowHeight)
                : Math.max(baseHeight * maxCols, minRowHeight, timeSlotHeight);

            if ($groupLabel.length) {
                var $groupItem = $groupLabel.find('.group-item');
                var groupItemWidth = $groupItem.outerWidth() || $groupLabel.outerWidth();
                $groupLabel.css({
                    width: groupItemWidth + 'px',
                    height: rowHeight + 'px'
                });
                $groupItem.css({ height: rowHeight + 'px' });
            }

            $timeslots.css({ height: rowHeight + 'px' });
            $timeslots.children('.timeslot').css({ height: rowHeight + 'px' });
        });

        // Hours row (00:00, 00:30, etc.) keeps fixed base height - only planning group rows expand for overlaps
    };

    return CalendarPlanningView;
});

